<div class="padding-top">
    <div class="content-grid mdl-grid agents">
        <div class="login-box">
            <h1>{{'AGENT_LOGIN' | translate}}</h1>
            <div class="login-agent">
                <div class="error" [hidden]="!errorLogin">
                    {{'LOGIN_INCORRECT' | translate}}
                </div>
                <div class="mdl-cell mdl-cell--10-col-desktop mdl-cell--12-col-phone mdl-cell--12-col-tablet input-agent">
                    <ng-container *ngIf="!isNode">
                        <input required [(ngModel)]="sysuser.email" matInput placeholder="{{'EMAIL' | translate}}" id="email" name="email" type="email">
                    </ng-container>
                </div>

                <div class="mdl-cell mdl-cell--10-col-desktop mdl-cell--12-col-phone mdl-cell--12-col-tablet input-agent">
                    <ng-container *ngIf="!isNode">
                        <input required [(ngModel)]="sysuser.password"  matInput placeholder="{{'PASSWORD' | translate}}" id="password" name="password" type="password">
                    </ng-container>
                </div>

                <div class="mdl-cell mdl-cell--10-col-desktop mdl-cell--12-col-phone mdl-cell--12-col-tablet">
                    <button *ngIf="!isNode" (click)="agentLogin(sysuser)" mat-raised-button color="primary" type="submit">{{'LOGIN' | translate}}</button>
                </div>
            </div>
        </div>
    </div>
</div>